import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  input,
  model,
  OnInit,
} from '@angular/core';
import { BaseFormControlComponent } from '../../../shared/components/base-form-control/base-form-control.component';
import { FormControlDirective } from '../../../shared/directives/form-control/form-control.directive';

@Component({
  selector: 'app-form-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  providers: [
    {
      provide: BaseFormControlComponent,
      useExisting: forwardRef(() => CheckboxComponent),
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormControlDirective],
  standalone: true,
})
export class CheckboxComponent
  extends BaseFormControlComponent<string | boolean | number>
  implements OnInit
{
  checkboxValue = input<string | number | undefined>();
  label = model<string>();
  size = input<'small' | 'medium' | 'large'>('small');

  override ngOnInit(): void {
    super.ngOnInit();

    if (!this.checkboxValue() && typeof this.value !== 'boolean') {
      this.setValue(false);
    }
  }

  onChange = (): void => {
    if (this.checkboxValue()) {
      const value: string | number | undefined = this.value
        ? undefined
        : this.checkboxValue();
      this.setValue(value);
    } else {
      this.setValue(!this.value);
    }
  };
}
